import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import "tom-select/dist/css/tom-select.bootstrap5.css"

// A self-contained alternative to initializers/input_components/tom_select.js
// for elements that can be inserted into the DOM after boot (e.g. squad rows
// added on the fly). That initializer relies on a globally-triggered
// 'cocoon:after-insert' jQuery event, which races against this app's own
// jQuery boot sequence — an element can be inserted and trigger that event
// before the initializer has registered its listener even once, leaving the
// element permanently un-enhanced. Stimulus connects controllers to matching
// elements via its own MutationObserver as soon as they enter the DOM, with
// no dependency on boot ordering, so it doesn't have that failure mode.
export default class extends Controller {
  static values = { remoteUrl: String, placeholder: String }

  connect() {
    if (this.element.tomselect) return

    const options = {
      plugins: this.element.multiple ? ['remove_button'] : [],
      placeholder: this.placeholderValue || 'Select',
      allowEmptyOption: true,
      // The squad table sits inside Bootstrap's .table-responsive, which sets
      // overflow-x: auto — per spec that forces overflow-y to a clipping
      // value too, so a dropdown positioned below the last row (or any row
      // without enough table content beneath it) gets cut off even though
      // it's otherwise rendered correctly. Rendering it into <body> escapes
      // that ancestor's clipping entirely; TomSelect still positions it
      // visually under the control.
      dropdownParent: 'body',
    }

    if (this.hasRemoteUrlValue) {
      Object.assign(options, {
        valueField: 'id',
        labelField: 'text',
        searchField: ['text'],
        load: (query, callback) => {
          const url = new URL(this.remoteUrlValue, window.location.origin)
          url.searchParams.set('q', query)
          fetch(url, { headers: { Accept: 'application/json' } })
            .then((response) => response.json())
            .then((json) => callback(json))
            .catch(() => callback())
        },
      })
    }

    new TomSelect(this.element, options)
  }

  disconnect() {
    if (this.element.tomselect) {
      this.element.tomselect.destroy()
    }
  }
}
